import { FilterTypeInput, Maybe, Scalars } from '@pylot-data/fwrdschema'
import { FilterInputData } from '../../FilterTypes'
import { SearchCriteria } from '../../hooks/use-plp-manager'

export const getSelectedItems = (
    appliedFilters: { [key: string]: FilterTypeInput },
    requestVar: string
): Array<Maybe<Scalars['String']>> => {
    if (!appliedFilters || !appliedFilters[requestVar]) {
        return []
    }
    const { eq, from, to, in: inCondition } = appliedFilters[requestVar]
    if (Array.isArray(inCondition)) {
        return inCondition
    } else if (eq) {
        return [String(eq)]
    } else if (from && to) {
        return [`${from}_${to}`]
    }
    return []
}

export const getSelectedItemsFromSearchCriteria = (
    selectedSearchCriteria: SearchCriteria[],
    option_attr_code: string
): Array<Maybe<Scalars['String']>> => {
    if (
        !selectedSearchCriteria ||
        selectedSearchCriteria.filter(
            (criterion) => criterion.attribute_code === option_attr_code
        ).length === 0
    ) {
        return []
    }
    const filteredCriteria = selectedSearchCriteria.filter(
        (criterion) => criterion.attribute_code === option_attr_code
    )
    return filteredCriteria.map((criterion) => criterion.filter_value)
}

export const getSelectedItemsFromFilterData = (
    appliedFilterData: Array<FilterInputData>,
    requestVar: string
): Array<Maybe<Scalars['String']>> => {
    if (
        !appliedFilterData ||
        appliedFilterData.filter(
            (criterion) => criterion.requestVar === requestVar
        ).length === 0
    ) {
        return []
    }
    const filteredCriteria = appliedFilterData.filter(
        (criterion) => criterion.requestVar === requestVar
    )

    return filteredCriteria.map((criterion) => criterion.value_string)
}
